import { createContext } from "react";

const userId = localStorage.getItem("userId");
const token = localStorage.getItem("token");
const role = localStorage.getItem("role");

export const initialState = {
  token,
  userId,
  role,
};

const AuthContext = createContext({
  user: null,
  setUser: () => {},
});

export const Logout = () => {
  localStorage.clear();
  window.location.reload();
};

export default AuthContext;
